<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <div class="form-group form-actions float-left pb-2">
          <!-- <b-button class="mr-2 btn" variant="success" size="md" @click="newEntity">
            <i class="fa fa-address-card-o"></i>
            Add Contact
          </b-button>-->
        </div>
        <div>
          <StyledDialog @filterList="filterList" :CurrentObject="mySelected" EntityType="TerritoryContact">
            <div slot="header">
              <h1>{{mySelected.Name}}</h1>
              <h4>{{mySelected.Territory.TerritoryName}}</h4>
            </div>
            <div slot="details">
              <div>
                <div>{{mySelected.Title}}</div>
                <div>{{mySelected.Email}}</div>
                <div>{{mySelected.Phone1}}</div>
              </div>
            </div>
            <span slot="entityType">Contact</span>
          </StyledDialog>
        </div>
      </b-col>
    </b-row>

    <b-row></b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredObjects"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRowsFiltered"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";
//import moment from "moment";

export default {
  name: "TerritoryContactList",
  data: () => {
    return {
      fields: [
        {
          key: "Functions",
          label: "",
          sortable: false,
          thStyle: "width: 5%;",
        },

        {
          key: "Territory.TerritoryName",
          label: "Territory",
          sortable: true,
        },
        {
          key: "Name",
          label: "Name",
          sortable: true,
        },
        { key: "Phone1", label: "Phone", sortable: true },
        { key: "Email", label: "Email", sortable: true },
      ],
      mySelected: { Territory: {} },
      currentPage: 1,
      perPage: 25,
      filteredObjects: [],
      searchString: "",
    };
  },
  components: {
    cTable,
    //DeleteDialog,
    StyledDialog,
  },
  props: {
    VendorID: -1,
  },
  created() {
    this.$store
      .dispatch("seminar/fetchTerritoryContacts")
      .then(this.filterList());
    //this.filteredCampaigns = this.$store.state.campaign.campaigns;
    //this.filterList();
  },
  computed: {
    totalRows: function () {
      return this.$store.state.seminar.territory_contacts.length;
      //return 4;
    },
    totalObjects: function () {
      return this.$store.state.seminar.territory_contacts;
      //return 4;
    },
    totalRowsFiltered: function () {
      return this.filteredObjects.length;
    },
    isNavVisible: function () {
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["territory", "seminar", "notification"]),
    ...mapActions("notification", ["add", "remove"]),
  },
  updated() {
    this.incrementCount;
  },
  watch: {
    totalObjects(newValue, oldValue) {
      this.filterList();
    },
  },
  methods: {
    filterList: function () {
      this.filteredObjects = this.$store.state.seminar.territory_contacts.filter(
        (contact) =>
          contact.TerritoryID ===
          this.$store.state.territory.territory_edit.TerritoryID
      );
    },
    resetSearch: function () {
      this.searchString = "";
      this.filterList();
    },
    incrementCount() {
      this.$store.commit("INCREMENT_COUNT");
    },
    SetItemToDelete(object) {
      this.mySelected = object;
    },
    myRowClickHandler(record, index) {
      this.$store
        .dispatch("seminar/loadTerritoryContactEdit", record.TerritoryContactID)
        .then(() => {
          this.$router.push({ name: "TerritoryContactProfile" });
        });
    },
    newEntity() {
      this.$store
        .dispatch("seminar/newTerritoryContact", this.createFreshObject())
        .then(() => {
          this.$router.push({ name: "TerritoryContactProfile" });
          //,
          //params: { id: this.event.id }
        })
        .catch((error) => {
          console.log(error.message);
          //.dispatch('notification/add', this.event)
        });
    },
    createFreshObject() {
      return {
        TerritoryContactID: -1,
        TerritoryID: this.$store.state.territory.territory_edit.TerritoryID,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
</style>